import {
  useHeldEmailQueueData,
  useHeldEmailQueueState,
} from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailQueueView } from "./HeldEmailQueueView";

export function HeldEmailQueuePanel() {
  const [state, dispatch] = useHeldEmailQueueState();
  const data = useHeldEmailQueueData(state);
  return (
    <HeldEmailQueueView
      model={{
        data: data.emails.data,
        dispatch,
        error: data.emails.error,
        filtered: data.filtered,
        loading: data.emails.isLoading,
        state,
        stats: data.stats.data,
        totalPages: data.totalPages,
      }}
    />
  );
}
